<template>
  <div class="unread-filter-chips" role="tablist" aria-label="Filter rooms by unread state">
    <button
      type="button"
      role="tab"
      :aria-selected="value === 'all'"
      :class="['chip', { 'chip-active': value === 'all' }]"
      @click="$emit('input', 'all')"
    >
      <span class="chip-label">All</span>
    </button>

    <button
      type="button"
      role="tab"
      :aria-selected="value === 'unread'"
      :class="['chip', { 'chip-active': value === 'unread', 'chip-has-count': unreadCount > 0 }]"
      @click="$emit('input', 'unread')"
    >
      <span class="chip-label">Unread</span>
      <span v-if="unreadCount > 0" class="chip-count">{{ unreadCount }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'UnreadFilterChips',
  props: {
    value: { type: String, default: 'all' },
    unreadCount: { type: Number, default: 0 },
  },
}
</script>

<style scoped lang="scss">
.unread-filter-chips {
  display: flex;
  gap: 8px;
  padding: 10px 12px 8px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;

  &:hover:not(.chip-active) {
    background: #e2e8f0;
    color: #1e293b;
  }

  &:focus-visible {
    outline: 2px solid #15803d;
    outline-offset: 2px;
  }
}

.chip-active {
  background: #15803d;
  color: #fff;
  box-shadow: 0 1px 2px rgba(21, 128, 61, 0.25);
  transform: scale(1.02);

  .chip-count {
    background: rgba(255, 255, 255, 0.22);
    color: #fff;
  }
}

.chip-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: #15803d;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

@media (max-width: 600px) {
  .unread-filter-chips {
    padding: 8px 10px 6px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .chip {
    flex-shrink: 0;
  }
}
</style>
